import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../constants/theme";
import NewsLetter from "../elements/NewsLetter";
import PageTitle from "../elements/PageTitle";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").trim();
const API_URL = API_BASE ? `${API_BASE.replace(/\/$/, "")}/courses/categories` : "";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPackages() {
      try {
        if (!API_URL) {
          throw new Error("REACT_APP_API_BASE_URL is missing. Add it in UserFront/.env");
        }

        setLoading(true);
        setError(null);
        console.log("Fetching categories from:", API_URL);

        const res = await fetch(API_URL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const responseText = await res.text();

        if (!res.ok) {
          throw new Error(`Failed to fetch packages: ${res.status} ${res.statusText}`);
        }

        let data;
        try {
          data = responseText ? JSON.parse(responseText) : [];
        } catch (parseError) {
          console.error("Invalid JSON response from API:", responseText.slice(0, 200));
          throw new Error("The API returned HTML instead of JSON. Check REACT_APP_API_BASE_URL.");
        }

        setPackages(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("fetchPackages error:", err);
        setError(err.message || "Failed to fetch packages");
      } finally {
        setLoading(false);
      }
    }

    fetchPackages();
  }, []);

  return (
    <div className="page-content" style={{ backgroundColor: "#fdffa2ff" }}>
      {/* === Page Header === */}
      <PageTitle parentTitle="Categories" />

      {/* === Packages Section === */}
      <section className="content-inner">
        <div className="container">
        {loading && !error && (
            <div
              className="boxes"
              style={{ margin: "40px auto", width: "96px", height: "64px" }}
            >
              <div className="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
          {error && <p className="text-danger">{error}</p>}

          <div className="packages-grid">
  {!loading && !error && packages.length > 0 ? (
    packages.map((pkg) => (
      <div className="package-card" key={pkg.id}>
        <img
          src={
            pkg.image_url ||
            IMAGES.placeholder ||
            "/images/default-package.jpg"
          }
          alt={pkg.name}
        />
        <div className="package-card-body">
          <div>
            <h4>{pkg.name}</h4>
            <p>{pkg.slug}</p>
          </div>
          <Link
            to={`/Categories/Category/${pkg.id}`}
            className="btn btn-dark"
          >
            View Details
          </Link>
        </div>
      </div>
    ))
  ) : (
    !loading && !error && <p>No packages available at the moment.</p>
  )}
</div>

        </div>
      </section>

      {/* === Newsletter Section === */}
      <section className="call-action style-1 footer-action">
        <div className="container">
          <NewsLetter />
        </div>
      </section>
    </div>
  );
};

export default Packages;
